<template>
    <ReactPage>
        <consumer-raffle-special-report-page></consumer-raffle-special-report-page>
    </ReactPage>
</template>

<script>
import ReactPage from '../components/ReactPage.vue';

export default {
    name: "ConsumerRaffleSpecialReport",
    components: {
        ReactPage
    }
}
</script>